import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn, ObjectParam, RoteiroAlerta } from '../shared/interface/generic-interface';
import { NotificationService } from '../shared/notification.service';

@Injectable({
  providedIn: 'root'
})
export class AlertasCardService {
  qtdAlertas = 0;
  private requestCache: Promise<any> | null = null;
  private requestIds: string = '';

  constructor(private conService: ApiConService, private notification: NotificationService) { }

  async getAlertas(idsRoteiros: string) {
    if (this.requestCache && this.requestIds === idsRoteiros) {
      return this.requestCache;
    }

    this.requestIds = idsRoteiros;
    this.requestCache = new Promise(async (resolve) => {
      try {
        const response: JsonReturn = await this.conService.patch('DCRoteiroAlerta/' + idsRoteiros);
        let alertas = response.response || [];
        this.qtdAlertas = alertas.length;
        resolve(alertas);
      } catch (error) {
        console.log(error);
        resolve([]);
      } finally {
        setTimeout(() => this.requestCache = null, 1000);
      }
    });

    return this.requestCache;
  }

  async updateVisualizadoAlertaRoteiro(objParam) {    
    try {
      const response = await this.conService.putBody('/DCRoteiroAlerta/visualizado', objParam); 
      if(response != undefined){
        this.notification.showSucesso("Alertas atualizados para visualizados!")
      }
    } catch (error) {
      console.log(error);
      this.notification.showErro("Erro ao atualizar alertas!")
    }
  }
}
